/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next'
import { Avatar } from '@mui/material'
import { PRIMARY_PINK, PRIMARY_GRASS_GREEN, PRIMARY_ORANGE, PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme'
import { useNavigate } from 'react-router-dom'
import { FC } from 'react'
import { translateGradeLevel } from 'utils/helpers'


const EarlyWarningCard: FC<any> = ({ student, step }) => {
  const { t } = useTranslation()
  
  const steps = [
    {},
    {title: `1. ${t('special.progress-monitoring')}`, color: PRIMARY_GRASS_GREEN},
    {title: `3. ${t('special.referral')}`, color: PRIMARY_ORANGE},
    {title: `4. ${t('special.create-iep')}`, color: PRIMARY_PINK},
  ]
  

  return (    
    <div style={{
      border: '1px solid #ccc', 
      borderRadius: '20px', 
      padding: '15px',
      width: '100%',
      margin: '1px'
    }}
    >

    <table style={{ margin: 'auto' }}><tbody><tr>
        {

          <td><div style={{ width: '100', textAlign: 'center', paddingRight: '10px', cursor: 'pointer'  }}>
            <Avatar
                      sx={{
                        bgcolor: PRIMARY_TRANSPARENT_GREEN,
                        width: 100,
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        margin: 'auto'
                      }}
                      variant='circular'
                      src={student.profile_picture || 'https://s3-esybee.childish.dev/avatars/1/avatar_e7f284bd-813b-4d7a-9fd9-bf59fdc28b87.png'}
                    >
            </Avatar>
          </div></td>
        }
        <td>
          <div style={{ fontSize: '12px', textAlign: 'left' }} className="avatar-info">
              <div>{ student.full_name }</div>
              <div style={{ marginTop: '1px' }}>#{ student.academic_id }</div>
              <div style={{ marginTop: '1px' }}>{ translateGradeLevel(student.grade_level) }</div>     
          </div>
        </td>
    </tr></tbody></table>


      {step && 
        <div style={{ marginTop: '10px' }}>
          <div style={{ color: steps[step].color, marginBottom: '5px' }}>
            {steps[step].title}
          </div>
          <div style={{ marginRight: '0px' }}>
            <div className='progress-bar-baseline' style={{background: 'gray', }}>
              <div className='progress-bar-baseline-fill' style={{ width: student.risk+'%' }}>
                <div className='progress-bar-baseline-percent'>{t('common.risk')}: {student.risk}%</div>
              </div>
            </div>
          </div>
        </div>
      }

    </div>
  )
}

export default EarlyWarningCard
